import { PriorClaimCategory } from "@covertree/new-business-graphql";
import { ClaimCategory } from "../validatorsAndTypes/claimsListForm";

const priorClaimCategoryToFormattedClaimCategoryMap = {
  [PriorClaimCategory.Flood]: ClaimCategory.Flood,
  [PriorClaimCategory.FireSmoke]: ClaimCategory.FireSmoke,
  [PriorClaimCategory.WeatherWind]: ClaimCategory.WeatherWind,
  [PriorClaimCategory.WeatherWater]: ClaimCategory.WeatherWater,
  [PriorClaimCategory.WeatherLightning]: ClaimCategory.WeatherLightning,
  [PriorClaimCategory.WeatherHail]: ClaimCategory.WeatherHail,
  [PriorClaimCategory.Earthquake]: ClaimCategory.Earthquake,
  [PriorClaimCategory.Liability]: ClaimCategory.Liability,
  [PriorClaimCategory.CollisionVehicleAircraft]:
    ClaimCategory.CollisionVehicleAircraft,
  [PriorClaimCategory.Other]: ClaimCategory.Other,
  [PriorClaimCategory.InteriorWater]: ClaimCategory.InteriorWater,
  [PriorClaimCategory.MedicalPayments]: ClaimCategory.MedicalPayments,
  [PriorClaimCategory.TheftBurglary]: ClaimCategory.TheftBurglary,
  [PriorClaimCategory.VandalismOrMaliciousMischief]:
    ClaimCategory.VandalismOrMaliciousMischief,
};

const formattedClaimCategoryToPriorClaimCategory = Object.fromEntries(
  Object.entries(priorClaimCategoryToFormattedClaimCategoryMap).map(
    ([key, value]) => [value, key]
  )
);

export const mapPriorClaimCategoryToFormattedClaimCategory = (
  category: PriorClaimCategory
): ClaimCategory => priorClaimCategoryToFormattedClaimCategoryMap[category];

export const mapFormattedClaimCategoryToPriorClaimCategory = (
  category: ClaimCategory
): PriorClaimCategory =>
  formattedClaimCategoryToPriorClaimCategory[category] as PriorClaimCategory;
